import React from 'react'

import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {PromosItem} from './PromosItem'

function Promos(props) {
  const displayItems = (props) => {
    if (props) {
      const promos = props.promos

      if (promos) {
        if (promos.length > 0) {
          return promos.map((promo, index) => {
            return (
              <PromosItem
                key={index}
                promo={promo}
                deletePromo={props.deletePromo}
                setPromos={props.setPromos}
              />
            )
          })
        } else {
          return <h3>No hay eventos</h3>
        }
      } else {
        return <h3>No hay eventos</h3>
      }
    } else {
      return <h3>No hay eventos</h3>
    }
  }

  return <>{displayItems(props)}</>
}

export {Promos}
